module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-parallax', {
    attrs: {
      "src": "https://chuszoof.files.wordpress.com/2014/11/material_wallpaper_set_two-1.jpg"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    staticClass: "white--text display-4"
  }, [_vm._v("Unit Converter")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.listUnit), function(unit, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs4": ""
      }
    }, [_c('v-card', {
      staticClass: "white--text mr-2 mb-2",
      attrs: {
        "color": unit.color
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', {
      staticClass: "headline"
    }, [_vm._v(_vm._s(unit.name))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$router.push(unit.href)
        }
      }
    }, [_vm._v("Convert now")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de331ef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 112
// module chunks = 0